module.exports = __webpack_public_path__ + "img/album18_41.e5f04841.jpg";